// extracted by mini-css-extract-plugin
var _1 = "NgAYWHJNw4PYRuTMIkmq";
var _2 = "cPqQJRNvUHMc0tmqSdoL";
var _3 = "P9A2VQ0dCTOLETP7MWxw";
var _4 = "SStMtob_TtahNzNu9qnE";
export { _1 as "button", _2 as "controls", _3 as "main", _4 as "play" }
